import {
    updateSettingsDialogViewState,
    updateOverriddenOptionOnSettingsDialogViewState,
    updateOverriddenCategoryOnSettingsDialogViewState,
} from '../actions/updateSettingsDialogViewState';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { trace } from 'owa-trace';

export const updateSettingsDialogViewStateMutator = mutator(
    updateSettingsDialogViewState,
    actionMessage => {
        const { settingsDialogViewState } = getStore();
        getStore().settingsDialogViewState = {
            ...settingsDialogViewState,
            ...actionMessage.options,
        };
    }
);

export const updateOverriddenOptionOnSettingsDialogViewStateMutator = mutator(
    updateOverriddenOptionOnSettingsDialogViewState,
    actionMessage => {
        const overriddenOptions = getStore().settingsDialogViewState.overriddenOptions;
        const newOverriddenOption = actionMessage.overriddenOption;
        trace.info(
            `[updateOverriddenOptionOnSettingsDialogViewStateMutator] Setting overridden option for id ${newOverriddenOption.id}`
        );
        overriddenOptions?.set(newOverriddenOption.id, { ...newOverriddenOption });
    }
);

export const updateOverriddenCategoryOnSettingsDialogViewStateMutator = mutator(
    updateOverriddenCategoryOnSettingsDialogViewState,
    actionMessage => {
        const overriddenCategories = getStore().settingsDialogViewState.overriddenCategories;
        const { categoryId, enabled } = actionMessage;
        trace.info(
            `[updateOverriddenCategoryOnSettingsDialogViewStateMutator] Setting overridden category for id ${categoryId} to ${enabled}`
        );
        overriddenCategories?.set(categoryId, enabled);
    }
);
